import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import * as React from "react";
import { TranslationService } from "../../services/TranslationService";
import { OfficeRoamingSettings } from "../../services/OfficeRoamingSettings";
import AppHeaderComponent from "./header/AppHeaderComponent";
import { HashRouter, Route, Switch } from "react-router-dom";
import { RedirectComponent } from "./RedirectComponent";
import SendAndFileFluent9 from "../sendAndFile/SendAndFileFluent9";
import { Authenticator } from "../../services/Authenticator";
import { NewformaApiClient } from "../../services/NewformaApi/NewformaApiClient";
import { AnalyticsManager } from "../../services/AnalyticsManager";
import { SmartFilingManager } from "../../services/SmartFiling/SmartFilingManager";
import LoginComponent from "../login/LoginComponent";
import { createHashHistory } from "history";
import { MailboxItem, OfficeWrapper } from "../../services/OfficeWrapper";
import { OfficeNotificationService } from "../../services/officeUi/OfficeNotificationService";
import { ConfigurationService } from "../../services/ConfigurationService";
import { UnauthenticatedNewformaApiClient } from "../../services/UnauthenticatedNewformaApiClient";
import ActionItemComponent from "../actionItem/ActionItemComponent";
import { ActionItemApiService } from "../../services/NewformaApi/ActionItemApiService";
import { StorageWrapper } from "../../services/StorageWrapper";
import { SessionStorageKeys } from "../../models/StorageKeys";
import { ConfigurationsApiService } from "../../services/NewformaApi/ConfigurationsApiService";
import { WindowWrapper } from "../../services/WindowWrapper";
import { FormValidationHelpers } from "../../helpers/FormValidationHelpers";
import { CustomerSupportEmailService } from "../../services/CustomerSupportEmailService";
import { Logger, Log } from "../../services/Logger";
import { IProjectsService } from "../../services/NewformaApi/IProjectsService";
import { SendAndFileHelpers } from "../../helpers/SendAndFile/SendAndFileHelpers";
import SubmittalComponent from "../submittal/SubmittalComponent";
import { DateHelpers } from "../../helpers/DateHelpers";
import { SubmittalsApiService } from "../../services/NewformaApi/SubmittalsApiService";
import { EulaApiService } from "../../services/NewformaApi/EulaApiService";
import { Eula } from "../../models/EulaModels";
import EulaComponent from "../eula/EulaComponent";
import RfiComponent from "../rfi/RfiComponent";
import RfiFluent9Component from "../rfi/RfiFluent9Component";
import { RfiApiService } from "../../services/NewformaApi/RfiApiService";
import { loadTheme } from "office-ui-fabric-react";
import { AppPage } from "../shared/navigationHeader/NavigationHeaderComponent";
import SubmittalReviewResponseComponent from "../submittal/submittalReviewResponse/SubmittalReviewResponseComponent";
import RfiReviewResponseComponent from "../rfi/rfiReviewResponse/RfiReviewResponseComponent";
import FileMultipleEmailFluent9 from "../fileMultipleEmail/FileMultipleEmailFluent9";
import NavigationHeaderComponent from "../shared/navigationHeader/NavigationHeaderComponent";
import { EmailApiService } from "../../services/NewformaApi/EmailApiService";
import { ProjectsApiService } from "../../services/NewformaApi/ProjectsApiService";
import { MsGraphApiService, resetNewformaFolderId } from "../../services/MsGraphApiService";
import { NrnServiceWrapper } from "../../services/NrnServiceWrapper";
import { AuthApiService } from "../../services/NewformaApi/AuthApiService";
import { TeachingBubblesTypes } from "../../models/TeachingBubblesTypes";
import { ThemeProvider } from "@material-ui/styles";
import { customThemes, darkTheme, darkThemeBodyBackground, lightTheme } from "../../services/ThemeService";
import { InvalidateCacheService } from "../../services/NewformaApi/InvalidateCacheService";
import { Messenger } from "../../services/Messenger";
import { FileTransferApiService } from "../../services/NewformaApi/FileTransferApiService";
import { OutlookApiService } from "../../services/OutlookApiService";
import ProgressComponent from "../shared/progress/ProgressComponent";
import { LocalStorageKeys } from "../../models/StorageKeys";
import ProjectItemComponent from "../projectItem/ProjectItemComponent";
import { UserDataResponse } from "../../models/UserDataResponse";
import { FluentProvider, Link, webDarkTheme, webLightTheme } from "@fluentui/react-components";
import { SmartFilingManagerFluent9 } from "@src/services/SmartFiling/SmartFilingManagerFluent9";
import { NewformaToast, NewformaToastHandle, NewformaToastIntent } from "../_base/Toast";
import { resetPrimingState } from "../../hooks/useFilteredProjects";

// this is necessary to make ProjectItemComponent displays correctly
import "../fileMultipleEmail/FileMultipleEmailComponent.less";

export function setRoamingItem(key: string, value: any): void {
    const roamingSettings = Office?.context?.roamingSettings;
    if (!roamingSettings) {
        return;
    }

    roamingSettings.set(key, value);
    roamingSettings.saveAsync();
}

export function setLocalStorageItem(key: string, value: any): void {
    window.localStorage.setItem(key, value);
}

export interface AppProps extends LocalizeContextProps {
    officeRoamingSettings: OfficeRoamingSettings;
    authenticator: Authenticator;
    apiClient: NewformaApiClient;
    unauthenticatedApiClient: UnauthenticatedNewformaApiClient;
    analyticsManager: AnalyticsManager;
    smartFilingManager: SmartFilingManager;
    smartFilingManagerFluent9: SmartFilingManagerFluent9;
    officeWrapper: OfficeWrapper;
    officeNotificationService: OfficeNotificationService;
    configService: ConfigurationService;
    actionItemApiService: ActionItemApiService;
    storageWrapper: StorageWrapper;
    configurationsApiService: ConfigurationsApiService;
    windowWrapper: WindowWrapper;
    formValidationHelpers: FormValidationHelpers;
    translationService: TranslationService;
    customerSupportEmailService: CustomerSupportEmailService;
    logger: Logger;
    projectsService: IProjectsService;
    sendAndFileHelpers: SendAndFileHelpers;
    dateHelpers: DateHelpers;
    submittalsApiService: SubmittalsApiService;
    eulaApiService: EulaApiService;
    rfiApiService: RfiApiService;
    emailApiService: EmailApiService;
    projectApiService: ProjectsApiService;
    msGraphApiService: MsGraphApiService;
    nrnServiceWrapper: NrnServiceWrapper;
    authApiService: AuthApiService;
    invalidateCacheService: InvalidateCacheService;
    messenger: Messenger;
    fileTransferApiService: FileTransferApiService;
    outlookApiService: OutlookApiService;
}

export interface AppState {
    isLoggedIn: boolean;
    deleteEmailAfterFilingSetting: boolean;
    fileEmailConversationSetting: boolean;
    showAllGlobalProjectsSetting: boolean;
    showEula: boolean;
    isEulaUpdate: boolean;
    lastToastMessage: string | null;
    onEulaUserResponse: ((eula: Eula | undefined) => void) | undefined;
    navigationPage: AppPage;
    isEulaSupported: boolean;
    isActionItemsSupported: boolean;
    isSubmittalsSupported: boolean;
    isRfiSupported: boolean;
    isFileRfiFluent9Supported: boolean;
    isRfiRespondCloseSupported: boolean;
    isProjectItemSupported: boolean;
    isProjectItemPendingExpectedSupported: boolean;
    isFileEmailIntoSubfolderSupported: boolean;
    isNL1221Supported: boolean;
    isFilePathInAttachmentSupported: boolean;
    isForwardSubmittalSupported: boolean;
    isForwardRfiSupported: boolean;
    isSubmittalRespondCloseSupported: boolean;
    isFileOnSendGlobalProjectsSupported: boolean;
    isFileOnSendGlobalProjectsNLVersionSupported: boolean;
    isSendFilesFromProjectSupported: boolean;
    isGlobalProjectSearchSupported: boolean;

    mailboxItem: MailboxItem | null;
    theme: string;
    entryPointUrl: string;
    locationPath: string;
    shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache: boolean;
    showFilesTransferTeachingBubble: boolean;
    showForwardRfiTeachingBubble: boolean;
    showForwardSubmittalTeachingBubble: boolean;
    showRespondAndCloseRfiTeachingBubble: boolean;
    showRespondAndCloseSubmittalTeachingBubble: boolean;
    showProjectItemTeachingBubble: boolean;
    hasMyProjects: boolean;
    shouldShowFileTransferPanel: boolean;
    isLoadingFileOnSendNewComponent: boolean;
    isMicrosoft365ToggleOn: boolean;
    isMicrosoft365EmailFeatureEnabled: boolean;
    culture: string;
    showForceEmailFiling: boolean;
    userData?: UserDataResponse;
}

Office.initialize = () => {
    // NOTE: Keep - required. This also fires before .async()
};
// tslint:disable-next-line
(async () => {
    await Office.onReady();
})();

class AppComponent extends React.Component<AppProps, AppState> {
    private history = createHashHistory();
    private readonly loginPath = "/login";
    private readonly infoToastKey = "newforma-info-message";
    private container: HTMLElement | null = null;
    private toastRef = React.createRef<NewformaToastHandle>();
    private addInLastOpenInterval: any;

    // Workaround for a known Office.js/Outlook issue where the ItemChanged event stops firing for a
    // pinned task pane after certain UI interactions (e.g. dropdown/picker selections), leaving the
    // add-in stuck showing data for a previously selected email. See:
    // https://github.com/OfficeDev/office-js/issues/1100 and https://github.com/OfficeDev/office-js/issues/5827
    // Mitigated here with 1) periodic re-registration of the handler (Microsoft's documented workaround)
    // and 2) a lightweight polling fallback that detects item/folder changes even if the event never fires.
    private readonly itemChangedBoundHandler = this.itemChanged.bind(this);
    private itemChangeWatcherInterval: any;
    private itemChangedHandlerReregisterInterval: any;
    private lastKnownItemId: string | undefined;
    private readonly ITEM_CHANGE_POLL_INTERVAL_MS = 2000;
    private readonly ITEM_CHANGED_HANDLER_REREGISTER_INTERVAL_MS = 60000;

    private logInfo = (message: string, object?: any): void => {
        if (this.props.logger.enabled) {
            this.props.logger.info(message, object);
        }
    };

    private setItem = (key: string, value: boolean | string | object) => {
        try {
            const stringValue = typeof value === "object" ? JSON.stringify(value) : value.toString();
            localStorage.setItem(key, stringValue);
        } catch {
            Log.info(`unexpected error setting "${key}`);
        }
    };

    private getObject = (key: any): any => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : undefined;
        } catch {
            Log.info(`unexpected error loading "${key}"`);
            return undefined;
        }
    };

    private getCachedCulture = (cachedUserData?: UserDataResponse): string => {
        try {
            return cachedUserData?.culture ?? (localStorage.getItem("newforma-culture") || "");
        } catch {
            Log.info('unexpected error loading "newforma-culture"');
            return cachedUserData?.culture ?? "";
        }
    };

    private refreshUserDataFromNpc = async (isClassicOutlook: boolean): Promise<void> => {
        try {
            const userData = await this.props.authApiService.getUserData();
            if (!userData) {
                return;
            }
            const culture = userData?.culture;
            const showForceEmailFiling = userData?.showForceEmailFiling;

            this.setItem("userData", userData);

            if (culture) {
                this.setItem("newforma-culture", culture);
                if (culture !== this.state.culture) {
                    this.setState({ culture });
                    void this.props.msGraphApiService?.setupFolders(culture);
                }
            }

            this.logInfo(`Received user culture from NPC: ${culture ?? "undefined"}`);
            this.logInfo(`Received showForceEmailFiling from NPC: ${showForceEmailFiling}`);
            isClassicOutlook
                ? setRoamingItem("showForceEmailFiling", showForceEmailFiling)
                : setLocalStorageItem("showForceEmailFiling", showForceEmailFiling);

            if (this.addInLastOpenInterval) {
                clearInterval(this.addInLastOpenInterval);
                this.addInLastOpenInterval = undefined;
            }

            if (showForceEmailFiling && !isClassicOutlook) {
                this.addInLastOpenInterval = setInterval(
                    () => setLocalStorageItem("addInLastOpen", Date.now().toString()),
                    1000
                );
            }
            this.setState({ showForceEmailFiling, userData });
        } catch (error) {
            this.logInfo(`Issue receiving user settings from NPC: ${error}`);
        }
    };

    private loadFeatures(): any {
        try {
            const features = this.getObject(LocalStorageKeys.features);
            return features;
        } catch {
            Log.info(`unexpected error loading "features"`);
            return undefined;
        }
    }

    private saveFeatureSupport() {
        const features = {
            isUpdateTime: new Date().toISOString(),
            // settings
            isNL1221Supported: this.state.isNL1221Supported, // no version
            isActionItemsSupported: this.state.isActionItemsSupported, // no version
            isRfiSupported: this.state.isRfiSupported, // no version
            isFileRfiFluent9Supported: this.state.isFileRfiFluent9Supported, // no version
            isSubmittalsSupported: this.state.isSubmittalsSupported, // no version

            isForwardRfiSupported: this.state.isForwardRfiSupported, // nl version check
            isRfiRespondCloseSupported: this.state.isRfiRespondCloseSupported, // nl version check
            isSubmittalRespondCloseSupported: this.state.isSubmittalRespondCloseSupported, // nl version check
            isProjectItemSupported: this.state.isProjectItemSupported,
            isSendFilesFromProjectSupported: this.state.isSendFilesFromProjectSupported,
            isGlobalProjectSearchSupported: this.state.isGlobalProjectSearchSupported,
        };

        this.setItem(LocalStorageKeys.features, JSON.stringify(features));
    }

    constructor(props: AppProps, context: AppState) {
        super(props, context);
        this.props.authenticator.onEulaRequired = this.onEulaRequired.bind(this);
        this.props.authenticator.onAuthenticationError = this.onAuthenticationError.bind(this);
        this.registerItemChangedHandler();
        this.lastKnownItemId = props.officeWrapper.getCurrentItemId();
        props.translationService.getTranslations(this.props);

        // first initialization with cached 'old' values
        const cached = this.loadFeatures();
        const cachedUserData = this.getObject("userData");
        const cachedCulture = this.getCachedCulture(cachedUserData);

        this.state = {
            isLoggedIn: this.props.authenticator.isUserLoggedIn(),
            deleteEmailAfterFilingSetting: this.props.officeRoamingSettings.getDeleteEmailAfterFiling(),
            fileEmailConversationSetting: this.props.officeRoamingSettings.getFileEmailConversation(),
            showAllGlobalProjectsSetting: this.props.officeRoamingSettings.getShowAllGlobalProjects(),
            showEula: false,
            isEulaUpdate: false,
            lastToastMessage: null,
            onEulaUserResponse: undefined,
            navigationPage: AppPage.FileMultipleEmail,
            isEulaSupported: false,

            // features we want to cache
            isActionItemsSupported: !!cached?.isActionItemsSupported,
            isSubmittalsSupported: !!cached?.isSubmittalsSupported,
            isRfiSupported: !!cached?.isRfiSupported,
            isFileRfiFluent9Supported: !!cached?.isFileRfiFluent9Supported,
            isRfiRespondCloseSupported: !!cached?.isRfiRespondCloseSupported,
            isProjectItemSupported: !!cached?.isProjectItemSupported,
            isProjectItemPendingExpectedSupported: !!cached?.isProjectItemPendingExpectedSupported,

            isNL1221Supported: !!cached?.isNL1221Supported,
            isForwardSubmittalSupported: !!cached?.isForwardSubmittalSupported,
            isForwardRfiSupported: !!cached?.isForwardRfiSupported,
            isSubmittalRespondCloseSupported: !!cached?.isSubmittalRespondCloseSupported,
            isSendFilesFromProjectSupported: !!cached?.isSendFilesFromProjectSupported,
            isGlobalProjectSearchSupported: !!cached?.isGlobalProjectSearchSupported,
            // end of cached features
            isFilePathInAttachmentSupported: false,
            isFileEmailIntoSubfolderSupported: false,
            isFileOnSendGlobalProjectsSupported: false,
            isFileOnSendGlobalProjectsNLVersionSupported: false,
            mailboxItem: this.props.officeWrapper.currentContextItem,
            theme: localStorage.getItem("theme") ?? "default",
            entryPointUrl: this.props.storageWrapper.loadSessionStorage(SessionStorageKeys.urlLocation) || "",
            locationPath: this.history.location.pathname,
            shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache: false,
            showFilesTransferTeachingBubble: false,
            showForwardRfiTeachingBubble: false,
            showForwardSubmittalTeachingBubble: false,
            showRespondAndCloseRfiTeachingBubble: false,
            showRespondAndCloseSubmittalTeachingBubble: false,
            showProjectItemTeachingBubble: false,
            hasMyProjects: true,
            shouldShowFileTransferPanel: false,
            isLoadingFileOnSendNewComponent: false,
            isMicrosoft365ToggleOn: false,
            isMicrosoft365EmailFeatureEnabled: false,
            culture: cachedCulture,
            showForceEmailFiling: false,

            userData: cachedUserData,
        };
    }

    async componentDidMount(): Promise<void> {
        const { configurationsApiService: config } = this.props;

        this.startItemChangeWatcher();
        this.startItemChangedHandlerReregistration();

        this.setState({ isLoadingFileOnSendNewComponent: true });
        const isClassicOutlook =
            Office.context && (Office.context.platform === Office.PlatformType.PC || Office.context.platform == null);
        try {
            let shouldShowInputFieldOnLogin;
            try {
                shouldShowInputFieldOnLogin = window.localStorage.getItem("newforma-shouldShowMicrosoft365InputField");
                if (shouldShowInputFieldOnLogin) {
                    shouldShowInputFieldOnLogin = JSON.parse(shouldShowInputFieldOnLogin);
                }
                this.setState({ isMicrosoft365ToggleOn: shouldShowInputFieldOnLogin });
            } catch (error) {
                this.logInfo(
                    `Issue receiving newforma-shouldShowMicrosoft365InputField value in localstorage: ${error}`
                );
            }

            let culture: string | undefined = this.state.culture || undefined;
            let hideAlert: boolean;

            try {
                const hideAlertLS = localStorage.getItem("hideAlert");

                if (hideAlertLS) {
                    hideAlert = hideAlertLS?.toLowerCase() === "true" ? true : false;
                    isClassicOutlook
                        ? setRoamingItem("hideAlert", hideAlert)
                        : setLocalStorageItem("hideAlert", hideAlert);
                } else {
                    isClassicOutlook ? setRoamingItem("hideAlert", false) : setLocalStorageItem("hideAlert", false);
                }
            } catch (error) {
                this.logInfo(`Issue receiving user settings from local storage: ${error}`);
            }
            void this.refreshUserDataFromNpc(isClassicOutlook);

            if (this.state.locationPath !== this.loginPath) {
                this.props.storageWrapper.saveSessionStorage(SessionStorageKeys.urlLocation, this.state.locationPath);
            }
            if (this.state.locationPath === "/fileemail" || this.state.entryPointUrl === "/fileemail") {
                this.props.storageWrapper.saveSessionStorage(SessionStorageKeys.urlLocation, "/filemultipleemail");
                this.setState({ locationPath: "/filemultipleemail", entryPointUrl: "/filemultipleemail" });
            }
            if (this.state.locationPath.toLocaleLowerCase().includes("sendandfile")) {
                this.setState({
                    entryPointUrl: "/sendandfile",
                    navigationPage: AppPage.SendAndFile,
                    isLoadingFileOnSendNewComponent: true,
                });
            }

            await this.props.msGraphApiService?.setupFolders(culture);

            this.state.isLoggedIn
                ? await config.getAuthenticatedConfigurations()
                : await config.getUnauthenticatedConfigurations();

            this.getFeatureSupport();
            try {
                const shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache = config.shouldTeachingBubbleBeShown(
                    TeachingBubblesTypes.fileMultipleEmail
                );
                const showFilesTransferTeachingBubble = config.shouldTeachingBubbleBeShown(
                    TeachingBubblesTypes.filesTransfer
                );
                const showForwardRfiTeachingBubble = config.shouldTeachingBubbleBeShown(
                    TeachingBubblesTypes.forwardReviewRfi
                );
                const showForwardSubmittalTeachingBubble = config.shouldTeachingBubbleBeShown(
                    TeachingBubblesTypes.forwardReviewSubmittal
                );
                const showRespondAndCloseRfiTeachingBubble = config.shouldTeachingBubbleBeShown(
                    TeachingBubblesTypes.respondAndCloseRfi
                );
                const showRespondAndCloseSubmittalTeachingBubble = config.shouldTeachingBubbleBeShown(
                    TeachingBubblesTypes.respondAndCloseSubmittal
                );
                const showProjectItemTeachingBubble = config.shouldTeachingBubbleBeShown(
                    TeachingBubblesTypes.projectItem
                );

                this.setState({
                    shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache,
                    showFilesTransferTeachingBubble,
                    showForwardRfiTeachingBubble,
                    showForwardSubmittalTeachingBubble,
                    showRespondAndCloseRfiTeachingBubble,
                    showRespondAndCloseSubmittalTeachingBubble,
                    showProjectItemTeachingBubble,
                });
            } catch (error) {
                Log.info(`An error occured setting teaching bubbles ${error}`);
            }
            try {
                this.getDropdownBoxShadow();
                this.container = document.getElementById("container");
                window.addEventListener("logoutEvent", this.handleLogoutEvent);
            } catch {
                Log.info(`An error occured prior to setting isLoadingFileOnSendNewComponent`);
            }
        } finally {
            this.setState({ isLoadingFileOnSendNewComponent: false });
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener("logoutEvent", this.handleLogoutEvent);
        if (this.addInLastOpenInterval) {
            clearInterval(this.addInLastOpenInterval);
            this.addInLastOpenInterval = undefined;
        }
        if (this.itemChangeWatcherInterval) {
            clearInterval(this.itemChangeWatcherInterval);
            this.itemChangeWatcherInterval = undefined;
        }
        if (this.itemChangedHandlerReregisterInterval) {
            clearInterval(this.itemChangedHandlerReregisterInterval);
            this.itemChangedHandlerReregisterInterval = undefined;
        }
        // Office.context.mailbox is a long-lived singleton independent of the React tree - without this,
        // the bound handler (and everything it closes over) would keep being invoked/held onto after unmount.
        this.props.officeWrapper.removeHandlerAsync(Office.EventType.ItemChanged);
    }

    private registerItemChangedHandler(): void {
        this.props.officeWrapper.addHandlerAsync(Office.EventType.ItemChanged, this.itemChangedBoundHandler);
    }

    // Microsoft's documented workaround for pinned task panes that stop receiving the ItemChanged
    // event after certain UI interactions (e.g. dropdown/picker changes) is to de-register and
    // re-register the handler. We do this defensively on an interval rather than trying to hook every
    // possible UI interaction that could trip the underlying platform bug.
    private startItemChangedHandlerReregistration(): void {
        this.itemChangedHandlerReregisterInterval = setInterval(() => {
            this.props.officeWrapper.removeHandlerAsync(Office.EventType.ItemChanged, {}, () => {
                this.registerItemChangedHandler();
            });
        }, this.ITEM_CHANGED_HANDLER_REREGISTER_INTERVAL_MS);
    }

    // Belt-and-suspenders fallback: even with re-registration, the ItemChanged event is not guaranteed
    // to fire on every Office build (see https://github.com/OfficeDev/office-js/issues/5827). Polling
    // the current item id catches folder/email switches that the event misses, so pages don't get
    // stuck showing stale data indefinitely.
    private startItemChangeWatcher(): void {
        this.itemChangeWatcherInterval = setInterval(() => {
            const currentItemId = this.props.officeWrapper.getCurrentItemId();
            if (currentItemId !== this.lastKnownItemId) {
                this.lastKnownItemId = currentItemId;
                this.itemChanged({ type: "olkItemSelectedChanged" });
            }
        }, this.ITEM_CHANGE_POLL_INTERVAL_MS);
    }

    async componentDidUpdate(prevProps: Readonly<AppProps>, prevState: Readonly<AppState>) {
        if (prevState.theme !== this.state.theme) {
            this.getDropdownBoxShadow();
        }
    }

    private buildToastBody(): React.ReactNode {
        if (this.state.hasMyProjects) {
            return;
        }

        return (
            <>
                {this.props.translate("SHARED.ERRORS.FOR_ADDITIONAL_HELP") as string}{" "}
                <Link
                    href="https://projectcenter.help.newforma.com/learning/how-tos/customize_my_project_center/"
                    target="_blank"
                    rel="noreferrer"
                >
                    {this.props.translate("SHARED.ERRORS.CLICK_HERE") as string}
                </Link>
            </>
        );
    }

    private showMultipleToasts = (toasts: { message: string; type: NewformaToastIntent }[]) => {
        const body = this.buildToastBody();

        const toastPayloads = toasts.map((toast) => ({
            title: toast.message,
            body,
            intent: toast.type,
        }));

        this.toastRef.current?.showMultipleToasts(toastPayloads);
        const lastMessage = toasts.length ? toasts[toasts.length - 1].message : null;
        this.setState({ lastToastMessage: lastMessage });
    };

    getDropdownBoxShadow() {
        document.documentElement.style.setProperty(
            "--dropdown-box-shadow",
            this.state.theme === "default" ? customThemes.boxShadowLight : customThemes.boxShadowDark
        );
        document.documentElement.style.setProperty(
            "--custom-border",
            this.state.theme === "default" ? customThemes.borderLight : customThemes.borderDark
        );
    }

    showNoProjectsToast() {
        this.setState({ hasMyProjects: false });
    }

    hideNoProjectsToast() {
        this.setState({ hasMyProjects: true });
    }

    async onEulaRequired(isUpdate: boolean): Promise<Eula | undefined> {
        this.logInfo(`AppComponent.onEulaRequired called with isUpdate:${isUpdate}`);
        return new Promise((resolve) => {
            this.setState({ showEula: true, isEulaUpdate: isUpdate, onEulaUserResponse: resolve });
        });
    }

    handleLogoutEvent = async (): Promise<void> => {
        await this.onUserLogOut();
    };

    handleDismissSuccessToasts = (e: React.PointerEvent<HTMLElement>): void => {
        // Don't dismiss the toast if they click directly on it
        if (e.target instanceof Element && e.target.closest(".newforma-toaster")) {
            return;
        }
        // Dismiss any success toasts if they click anywhere else
        this.toastRef.current?.dismissSuccess();
    };

    closeOrOpenFileTransferPanel(shouldShow: boolean) {
        this.setState({ shouldShowFileTransferPanel: shouldShow });
    }

    async onUserLogOut(): Promise<void> {
        this.props.authenticator.logoutFromApp();
        this.props.authApiService.clearUserDataCache();
        resetPrimingState();
        resetNewformaFolderId();
        this.setState({ isLoggedIn: false, shouldShowFileTransferPanel: false });
        if (!this.state.isMicrosoft365ToggleOn) {
            try {
                window.localStorage.removeItem("newforma-email");
            } catch (error) {
                this.logInfo(`Issue removing Microsoft 365 email value from local storage: ${error}`);
            }
        }
    }

    async onApiLogIn(): Promise<void> {
        await this.props.configurationsApiService.getAuthenticatedConfigurations();

        let culture = this.state.culture;
        try {
            const userData = await this.props.authApiService.getUserData();
            if (userData) {
                culture = userData.culture;
                this.setItem("userData", userData);
                this.setItem("newforma-culture", culture);
                this.setState({ culture, userData, showForceEmailFiling: userData.showForceEmailFiling });
            }
        } catch (error) {
            this.logInfo(`Issue receiving user culture from NPC after login: ${error}`);
        }

        // Fire setupFolders without blocking — SendAndFileComponent will await the result via waitForNewformaFolderId()
        void this.props.msGraphApiService?.setupFolders(culture);

        const shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache = this.props.configurationsApiService.shouldTeachingBubbleBeShown(
            TeachingBubblesTypes.fileMultipleEmail
        );
        const showFilesTransferTeachingBubble = this.props.configurationsApiService.shouldTeachingBubbleBeShown(
            TeachingBubblesTypes.filesTransfer
        );
        const showProjectItemTeachingBubble = this.props.configurationsApiService.shouldTeachingBubbleBeShown(
            TeachingBubblesTypes.projectItem
        );

        this.getFeatureSupport();

        this.setState({
            isLoggedIn: true,
            shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache,
            showFilesTransferTeachingBubble,
            showProjectItemTeachingBubble,
        });
        this.onMicrosoft365EmailFeatureToggleChange(this.state.isMicrosoft365EmailFeatureEnabled);
    }

    onMicrosoft365EmailFeatureToggleChange(launchDarklyToggleValue: boolean): void {
        if (!launchDarklyToggleValue) {
            try {
                window.localStorage.removeItem("newforma-email");
                window.localStorage.setItem("newforma-shouldShowMicrosoft365InputField", JSON.stringify(false));
            } catch (error) {
                this.logInfo(`Issue removing Microsoft 365 values from local storage: ${error}`);
            }
        }
    }

    onSettingsChanged(): void {
        const deleteAfterFiling = this.props.officeRoamingSettings.getDeleteEmailAfterFiling();
        const fileConversation = this.props.officeRoamingSettings.getFileEmailConversation();
        const showAllGlobalProjects = this.props.officeRoamingSettings.getShowAllGlobalProjects();
        this.setState({
            deleteEmailAfterFilingSetting: deleteAfterFiling,
            fileEmailConversationSetting: fileConversation,
            theme: localStorage.getItem("theme") ?? "default",
            showAllGlobalProjectsSetting: showAllGlobalProjects,
        });
    }

    async onAuthenticationError(errorMessage: string): Promise<void> {
        await this.showToast(this.props.translate(errorMessage) as string, "error");
    }

    private async itemChanged(_eventArgs: any): Promise<void> {
        // Used to trap email selection changes if the Task Pane is pinned
        this.logInfo("Selected mail item changed");
        const mailboxItem = this.props.officeWrapper.currentContextItem;
        this.lastKnownItemId = this.props.officeWrapper.getCurrentItemId();
        if (_eventArgs.type !== "olkItemSelectedChanged" || !mailboxItem) {
            this.setState({ mailboxItem: null });
            return;
        }

        this.setState({ mailboxItem });
    }

    private async handleEulaResponse(eula: Eula | undefined): Promise<void> {
        if (this.state.onEulaUserResponse) {
            this.state.onEulaUserResponse(eula);
        }
        this.setState({ showEula: false, isEulaUpdate: false, onEulaUserResponse: undefined });
    }

    private async showToast(message: string | null, type: NewformaToastIntent): Promise<void> {
        if (!message) {
            return;
        }

        this.toastRef.current?.showToast({ title: message, intent: type, body: this.buildToastBody() });
        this.setState({ lastToastMessage: message });
        this.props.officeNotificationService.showInfoToast(this.state.mailboxItem, this.infoToastKey, message);
    }

    private onToastDismissed(): void {
        this.toastRef.current?.dismissAll();
        this.setState({ lastToastMessage: null });
        this.props.officeNotificationService.dismissInfoToast(this.state.mailboxItem, this.infoToastKey);
    }

    private setNavigationPage(page: AppPage): void {
        this.setState({ navigationPage: page });
    }

    private getFeatureSupport(): void {
        const { configurationsApiService: config } = this.props;

        this.setState({
            isEulaSupported: config.isEulaSupported(),

            isRfiSupported: config.isRfiSupported(),
            isFileRfiFluent9Supported: config.isFileRfiFluent9Supported(),
            isActionItemsSupported: config.isActionItemsSupported(),
            isSubmittalsSupported: config.isSubmittalsSupported(),
            // what is being returned from the configurationsApiService for isFileTransferAndEditorSupported is the check of whether NL version is greater than 1.2.21 or not - the returned value is a boolean
            isFilePathInAttachmentSupported: config.isFilePathSupportedInAttachments(),
            isForwardSubmittalSupported:
                config.isForwardSubmittalSupported() && config.isForwardSubmittalAndRfiSupportedBasedOnNLVersion(),
            isForwardRfiSupported:
                config.isForwardRfiSupported() && config.isForwardSubmittalAndRfiSupportedBasedOnNLVersion(),
            isSubmittalRespondCloseSupported:
                config.isSubmittalRespondCloseSupported() &&
                config.isSubmittalRespondAndCloseSupportedBasedOnNLVersion(),
            isRfiRespondCloseSupported:
                config.isRfiRespondCloseSupported() && config.isRfiRespondAndCloseSupportedBasedOnNLVersion(),
            isNL1221Supported: config.isSupportedByNL1221Version(),
            isProjectItemSupported:
                config.isFileIntoAnItemSupported() && config.isProjectItemSupportedBasedOnNLVersion(),
            isProjectItemPendingExpectedSupported:
                config.isFileIntoAnItemSupported() &&
                config.isProjectItemSupportedBasedOnNLVersion() &&
                config.isProjectItemPendingExpectedSupported(),

            isFileEmailIntoSubfolderSupported:
                config.isFileEmailIntoSubfolderSupported() && config.isProjectSubfolderSupportedBasedOnNLVersion(),
            isSendFilesFromProjectSupported: config.isSendFilesFromProjectSupported(),
            isGlobalProjectSearchSupported: config.isGlobalProjectSearchSupported(),
        });
        // always update
        this.saveFeatureSupport();

        // other params not cached
        this.setState({
            isFileOnSendGlobalProjectsSupported: config.isFileOnSendGlobalProjectsSupported(),
            isFileOnSendGlobalProjectsNLVersionSupported: config.isFileOnSendGlobalProjectsSupportedBasedOnNLVersion(),
            isMicrosoft365EmailFeatureEnabled: config.isSignInFieldOnLoginPage(),
        });
    }

    private async dismissMultipleEmailsTeachingBubble(): Promise<void> {
        try {
            this.setState({ shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache: false });
            this.props.configurationsApiService.updateCompletedTeachingBubblesCollection(
                TeachingBubblesTypes.fileMultipleEmail
            );
            await this.props.configurationsApiService.updateCompletedTeachingBubblesSteps([
                TeachingBubblesTypes.fileMultipleEmail,
            ]);
        } catch (error) {
            this.props.logger.error("Multiple Emails: Error updating teaching bubbles.", error);
        }
    }

    private async dismissFileTransferTeachingBubble(): Promise<void> {
        try {
            this.setState({ showFilesTransferTeachingBubble: false });
            this.props.configurationsApiService.updateCompletedTeachingBubblesCollection(
                TeachingBubblesTypes.filesTransfer
            );
            await this.props.configurationsApiService.updateCompletedTeachingBubblesSteps([
                TeachingBubblesTypes.filesTransfer,
            ]);
        } catch (error) {
            this.props.logger.error("File Transfer: Error updating teaching bubbles.", error);
        }
    }

    private dismissRfiTeachingBubble = async () => {
        this.setState({ showForwardRfiTeachingBubble: false });
        await this.props.configurationsApiService.updateCompletedTeachingBubblesSteps([
            TeachingBubblesTypes.forwardReviewRfi,
        ]);
    };

    private dismissSubmittalTeachingBubble = async () => {
        this.setState({ showForwardSubmittalTeachingBubble: false });
        await this.props.configurationsApiService.updateCompletedTeachingBubblesSteps([
            TeachingBubblesTypes.forwardReviewSubmittal,
        ]);
    };

    private dismissRespondAndCloseRfiTeachingBubble = async () => {
        this.setState({ showRespondAndCloseRfiTeachingBubble: false });
        await this.props.configurationsApiService.updateCompletedTeachingBubblesSteps([
            TeachingBubblesTypes.respondAndCloseRfi,
        ]);
    };

    private dismissRespondAndCloseSubmittalTeachingBubble = async () => {
        this.setState({ showRespondAndCloseSubmittalTeachingBubble: false });
        await this.props.configurationsApiService.updateCompletedTeachingBubblesSteps([
            TeachingBubblesTypes.respondAndCloseSubmittal,
        ]);
    };

    private dismissProjectItemTeachingBubble = async () => {
        this.setState({ showProjectItemTeachingBubble: false });
        await this.props.configurationsApiService.updateCompletedTeachingBubblesSteps([
            TeachingBubblesTypes.projectItem,
        ]);
    };

    onMicrosoft365ToggleChanged(toggleValue: boolean): void {
        this.setState({ isMicrosoft365ToggleOn: toggleValue });
    }

    renderFileOnSendComponent(): JSX.Element {
        return (
            <FluentProvider
                style={{ display: "contents" }}
                theme={this.state.theme === "default" ? webLightTheme : webDarkTheme}
            >
                <SendAndFileFluent9
                    theme={this.state.theme}
                    officeRoamingSettings={this.props.officeRoamingSettings}
                    smartFilingManager={this.props.smartFilingManagerFluent9}
                    onExpiredSession={this.onUserLogOut.bind(this)}
                    officeWrapper={this.props.officeWrapper}
                    officeNotificationService={this.props.officeNotificationService}
                    analyticsManager={this.props.analyticsManager}
                    logger={this.props.logger}
                    projectsService={this.props.projectsService}
                    sendAndFileHelpers={this.props.sendAndFileHelpers}
                    onSetNavigationPage={this.setNavigationPage.bind(this)}
                    onShowToast={this.showToast.bind(this)}
                    mailboxItem={this.state.mailboxItem}
                    emailApiService={this.props.emailApiService}
                    projectApiService={this.props.projectApiService}
                    invalidateCacheService={this.props.invalidateCacheService}
                    msGraphApiService={this.props.msGraphApiService}
                    useGlobalProjects={
                        this.state.showAllGlobalProjectsSetting &&
                        this.state.isFileOnSendGlobalProjectsSupported &&
                        this.state.isFileOnSendGlobalProjectsNLVersionSupported
                    }
                    isGlobalProjectSearchSupported={this.state.isGlobalProjectSearchSupported}
                    isFileEmailIntoSubfolderSupported={this.state.isFileEmailIntoSubfolderSupported}
                    authApiService={this.props.authApiService}
                    culture={this.state.culture}
                    forceEmailFilingSetting={this.state.showForceEmailFiling}
                />
            </FluentProvider>
        );
    }
    renderFileMultipleEmailFluentUI9Component(): JSX.Element {
        const {
            analyticsManager,
            authApiService,
            emailApiService,
            invalidateCacheService,
            logger,
            messenger,
            msGraphApiService,
            nrnServiceWrapper,
            officeNotificationService,
            officeRoamingSettings,
            projectsService,
            smartFilingManagerFluent9,
        } = this.props;
        const {
            culture,
            deleteEmailAfterFilingSetting,
            isFileEmailIntoSubfolderSupported,
            isGlobalProjectSearchSupported,
            mailboxItem,
            shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache,
            theme,
        } = this.state;
        return (
            <FileMultipleEmailFluent9
                // handlers
                hideNoProjectsToast={this.hideNoProjectsToast.bind(this)}
                onDismissTeachingBubble={this.dismissMultipleEmailsTeachingBubble.bind(this)}
                onExpiredSession={this.onUserLogOut.bind(this)}
                onSetNavigationPage={this.setNavigationPage.bind(this)}
                onShowToast={this.showToast.bind(this)}
                showNoProjectsToast={this.showNoProjectsToast.bind(this)}
                // classes
                analyticsManager={analyticsManager}
                authApiService={authApiService}
                culture={culture}
                deleteEmailAfterFiling={deleteEmailAfterFilingSetting}
                emailApiService={emailApiService}
                invalidateCacheService={invalidateCacheService}
                isFileEmailIntoSubfolderSupported={isFileEmailIntoSubfolderSupported}
                isGlobalProjectSearchSupported={isGlobalProjectSearchSupported}
                logger={logger}
                mailboxItem={mailboxItem}
                messenger={messenger}
                msGraphApiService={msGraphApiService}
                nrnServiceWrapper={nrnServiceWrapper}
                officeNotificationService={officeNotificationService}
                officeRoamingSettings={officeRoamingSettings}
                projectsService={projectsService}
                shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache={
                    shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache
                }
                smartFilingManager={smartFilingManagerFluent9}
                theme={theme}
            />
        );
    }

    renderRfiComponent(): JSX.Element {
        if (this.state.isFileRfiFluent9Supported) {
            return (
                <RfiFluent9Component
                    logger={this.props.logger}
                    onExpiredSession={this.onUserLogOut.bind(this)}
                    onShowToast={this.showToast.bind(this)}
                    onSetNavigationPage={this.setNavigationPage.bind(this)}
                    mailboxItem={this.state.mailboxItem}
                    emailApiService={this.props.emailApiService}
                    msGraphApiService={this.props.msGraphApiService}
                    analyticsManager={this.props.analyticsManager}
                    smartFilingManager={this.props.smartFilingManagerFluent9}
                    invalidateCacheService={this.props.invalidateCacheService}
                    projectsService={this.props.projectsService}
                    officeWrapper={this.props.officeWrapper}
                    nrnServiceWrapper={this.props.nrnServiceWrapper}
                    theme={this.state.theme}
                    culture={this.state.culture}
                />
            );
        }

        return (
            <RfiComponent
                configurationsApiService={this.props.configurationsApiService}
                smartFilingManager={this.props.smartFilingManager}
                logger={this.props.logger}
                onExpiredSession={this.onUserLogOut.bind(this)}
                projectsService={this.props.projectsService}
                formValidationHelpers={this.props.formValidationHelpers}
                officeWrapper={this.props.officeWrapper}
                dateHelpers={this.props.dateHelpers}
                rfiApiService={this.props.rfiApiService}
                onShowToast={this.showToast.bind(this)}
                onSetNavigationPage={this.setNavigationPage.bind(this)}
                mailboxItem={this.state.mailboxItem}
                analyticsManager={this.props.analyticsManager}
                nrnServiceWrapper={this.props.nrnServiceWrapper}
                msGraphApiService={this.props.msGraphApiService}
                theme={this.state.theme}
                invalidateCacheService={this.props.invalidateCacheService}
                isFilePathInAttachmentsSupported={this.state.isFilePathInAttachmentSupported}
                isNL1221Supported={this.state.isNL1221Supported}
                configService={this.props.configService}
                isForwardRfiSupported={this.state.isForwardRfiSupported}
                showForwardRfiTeachingBubble={this.state.showForwardRfiTeachingBubble}
                onDismissTeachingBubble={this.dismissRfiTeachingBubble}
                culture={this.state.culture}
                outlookApiService={this.props.outlookApiService}
            />
        );
    }

    render(): JSX.Element {
        Log.info(`Path [${this.state.locationPath}]`);
        Log.info(`isACT ${this.state.isActionItemsSupported}`);
        Log.info(`isSRC ${this.state.isSubmittalRespondCloseSupported}`);
        Log.info(`isRRC ${this.state.isRfiRespondCloseSupported}`);
        Log.info(`isPRI ${this.state.isProjectItemSupported}`);
        Log.info(`isFTE ${this.state.isNL1221Supported}`);
        const isFOS = this.state.locationPath.toLocaleLowerCase().includes("sendandfile");
        const useFluent9NavigationSurface =
            this.state.isLoggedIn &&
            (this.state.navigationPage === AppPage.FileMultipleEmail ||
                this.state.navigationPage === AppPage.SendAndFile);
        return (
            <ThemeProvider theme={this.state.theme === "default" ? loadTheme(lightTheme) : loadTheme(darkTheme)}>
                <div
                    className="newforma-appMain"
                    data-theme={this.state.theme}
                    onPointerDownCapture={this.handleDismissSuccessToasts}
                >
                    <FluentProvider theme={this.state.theme === "default" ? webLightTheme : webDarkTheme}>
                        <NewformaToast ref={this.toastRef} />
                    </FluentProvider>
                    <AppHeaderComponent
                        loggedIn={this.state.isLoggedIn}
                        onLogOut={this.onUserLogOut.bind(this)}
                        analyticsManager={this.props.analyticsManager}
                        configService={this.props.configService}
                        officeRoamingSettings={this.props.officeRoamingSettings}
                        officeWrapper={this.props.officeWrapper}
                        authenticator={this.props.authenticator}
                        logger={this.props.logger}
                        customerSupportEmailService={this.props.customerSupportEmailService}
                        windowWrapper={this.props.windowWrapper}
                        onSettingsChanged={this.onSettingsChanged.bind(this)}
                        isEulaSupported={this.state.isEulaSupported}
                        mailboxItem={this.state.mailboxItem}
                        smartFilingManager={this.props.smartFilingManager}
                        smartFilingManagerFluent9={this.props.smartFilingManagerFluent9}
                        projectsService={this.props.projectsService}
                        emailApiService={this.props.emailApiService}
                        onExpiredSession={this.onUserLogOut.bind(this)}
                        sendAndFileHelpers={this.props.sendAndFileHelpers}
                        onShowToast={this.showToast.bind(this)}
                        onDismissToast={this.onToastDismissed.bind(this)}
                        formValidationHelpers={this.props.formValidationHelpers}
                        nrnServiceWrapper={this.props.nrnServiceWrapper}
                        msGraphApiService={this.props.msGraphApiService}
                        configurationService={this.props.configurationsApiService}
                        submittalsApiService={this.props.submittalsApiService}
                        storageWrapper={this.props.storageWrapper}
                        theme={this.state.theme}
                        dateHelpers={this.props.dateHelpers}
                        rfiApiService={this.props.rfiApiService}
                        invalidateCacheService={this.props.invalidateCacheService}
                        fileTransferApiService={this.props.fileTransferApiService}
                        showFilesTransferTeachingBubble={this.state.showFilesTransferTeachingBubble}
                        shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache={
                            this.state.shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache
                        }
                        onDismissTeachingBubble={this.dismissFileTransferTeachingBubble.bind(this)}
                        outlookApiService={this.props.outlookApiService}
                        showFileTransferButton={this.state.isNL1221Supported && !isFOS}
                        isFilePathInAttachmentsSupported={this.state.isFilePathInAttachmentSupported}
                        hideNoProjectsToast={this.hideNoProjectsToast.bind(this)}
                        shouldShowFileTransferPanel={this.closeOrOpenFileTransferPanel.bind(this)}
                        shouldShowFileTransferView={this.state.shouldShowFileTransferPanel}
                        hideSearchTeamBtns={isFOS}
                        onMicrosoft365EmailToggleChanged={this.onMicrosoft365ToggleChanged.bind(this)}
                        isMicrosoft365EmailFeatureEnabled={this.state.isMicrosoft365EmailFeatureEnabled}
                        showProjectItemTeachingBubble={
                            this.state.isProjectItemSupported && this.state.showProjectItemTeachingBubble
                        }
                        onDismissProjectItemTeachingBubble={this.dismissProjectItemTeachingBubble}
                        toastMessageFromParent={this.state.lastToastMessage}
                        isSendFilesFromProjectSupported={this.state.isSendFilesFromProjectSupported}
                        isGlobalProjectSearchSupported={this.state.isGlobalProjectSearchSupported}
                        useFluent9Surface={useFluent9NavigationSurface}
                    />
                    {this.state.showEula ? (
                        <EulaComponent
                            onEulaResponse={this.handleEulaResponse.bind(this)}
                            eulaService={this.props.eulaApiService}
                            logger={this.props.logger}
                            analyticsManager={this.props.analyticsManager}
                            isEulaPreviouslyAccepted={this.state.isEulaUpdate}
                            theme={this.state.theme}
                        />
                    ) : null}
                    <HashRouter>
                        {this.state.isLoggedIn ? (
                            <div id="header" key="header" className="newforma-flexHeader">
                                <NavigationHeaderComponent
                                    defaultSelectedKey={this.state.navigationPage}
                                    onNavigationChange={this.setNavigationPage.bind(this)}
                                    isLoggedIn={this.state.isLoggedIn}
                                    isRfiSupported={this.state.isRfiSupported}
                                    isSubmittalsSupported={this.state.isSubmittalsSupported}
                                    isActionItemsSupported={this.state.isActionItemsSupported}
                                    isProjectItemSupported={this.state.isProjectItemSupported}
                                    location={this.state.locationPath}
                                    theme={this.state.theme}
                                    hideNoProjectsToast={this.hideNoProjectsToast.bind(this)}
                                    submittalsApiService={this.props.submittalsApiService}
                                    userData={this.state.userData}
                                    useFluent9Surface={useFluent9NavigationSurface}
                                />
                            </div>
                        ) : null}

                        <Switch>
                            <Route exact path="/login">
                                <LoginComponent
                                    isLoggedIn={this.state.isLoggedIn}
                                    authenticator={this.props.authenticator}
                                    onApiLogin={this.onApiLogIn.bind(this)}
                                    redirectUrl={this.state.entryPointUrl}
                                    apiClient={this.props.unauthenticatedApiClient}
                                    officeWrapper={this.props.officeWrapper}
                                    logger={this.props.logger}
                                    eulaService={this.props.eulaApiService}
                                    onEulaDecline={this.onUserLogOut.bind(this)}
                                    analyticsManager={this.props.analyticsManager}
                                    isEulaSupported={this.state.isEulaSupported}
                                    theme={this.state.theme}
                                    isSignInFieldOnLoginPageSupported={this.state.isMicrosoft365ToggleOn}
                                    formValidationHelpers={this.props.formValidationHelpers}
                                />
                            </Route>
                            <RedirectComponent key={1} isLoggedIn={this.state.isLoggedIn}>
                                <Route exact path={["/", "/filemultipleemail", "/fileemail"]}>
                                    {this.renderFileMultipleEmailFluentUI9Component()}
                                </Route>

                                <Route exact path="/sendandfile">
                                    {this.state.isLoadingFileOnSendNewComponent ? (
                                        <div
                                            className="newforma-SendAndFileComponent"
                                            style={{
                                                flex: 1,
                                                backgroundColor:
                                                    this.state.theme === "default"
                                                        ? "#ffffff"
                                                        : darkThemeBodyBackground,
                                            }}
                                        >
                                            <ProgressComponent
                                                message={this.props.translate("APP.LOADING_PROJECTS") as string}
                                            />
                                        </div>
                                    ) : (
                                        this.renderFileOnSendComponent()
                                    )}
                                </Route>
                                <Route exact path="/actionitem">
                                    <ActionItemComponent
                                        officeWrapper={this.props.officeWrapper}
                                        analyticsManager={this.props.analyticsManager}
                                        actionItemApiService={this.props.actionItemApiService}
                                        onExpiredSession={this.onUserLogOut.bind(this)}
                                        formValidationHelpers={this.props.formValidationHelpers}
                                        logger={this.props.logger}
                                        projectsService={this.props.projectsService}
                                        configurationService={this.props.configurationsApiService}
                                        smartFilingManager={this.props.smartFilingManager}
                                        onSetNavigationPage={this.setNavigationPage.bind(this)}
                                        onShowToast={this.showToast.bind(this)}
                                        mailboxItem={this.state.mailboxItem}
                                        msGraphApiService={this.props.msGraphApiService}
                                        nrnServiceWrapper={this.props.nrnServiceWrapper}
                                        theme={this.state.theme}
                                        invalidateCacheService={this.props.invalidateCacheService}
                                        isFilePathInAttachmentsSupported={this.state.isFilePathInAttachmentSupported}
                                        configService={this.props.configService}
                                        isNL1221Supported={this.state.isNL1221Supported}
                                        culture={this.state.culture}
                                        outlookApiService={this.props.outlookApiService}
                                    />
                                </Route>
                                <Route exact path="/submittal">
                                    <SubmittalComponent
                                        logger={this.props.logger}
                                        officeWrapper={this.props.officeWrapper}
                                        configurationService={this.props.configurationsApiService}
                                        formValidationHelpers={this.props.formValidationHelpers}
                                        projectsService={this.props.projectsService}
                                        onExpiredSession={this.onUserLogOut.bind(this)}
                                        dateHelpers={this.props.dateHelpers}
                                        analyticsManager={this.props.analyticsManager}
                                        submittalsApiService={this.props.submittalsApiService}
                                        smartFilingManager={this.props.smartFilingManager}
                                        onSetNavigationPage={this.setNavigationPage.bind(this)}
                                        onShowToast={this.showToast.bind(this)}
                                        showMultipleToasts={this.showMultipleToasts.bind(this)}
                                        mailboxItem={this.state.mailboxItem}
                                        nrnServiceWrapper={this.props.nrnServiceWrapper}
                                        msGraphApiService={this.props.msGraphApiService}
                                        theme={this.state.theme}
                                        invalidateCacheService={this.props.invalidateCacheService}
                                        isFilePathInAttachmentsSupported={this.state.isFilePathInAttachmentSupported}
                                        isNL1221Supported={this.state.isNL1221Supported}
                                        isForwardSubmittalSupported={this.state.isForwardSubmittalSupported}
                                        configService={this.props.configService}
                                        showForwardSubmittalTeachingBubble={
                                            this.state.showForwardSubmittalTeachingBubble
                                        }
                                        onDismissTeachingBubble={this.dismissSubmittalTeachingBubble}
                                        culture={this.state.culture}
                                        outlookApiService={this.props.outlookApiService}
                                    />
                                </Route>
                                <Route exact path="/submittalreviewresponse">
                                    <SubmittalReviewResponseComponent
                                        logger={this.props.logger}
                                        onExpiredSession={this.onUserLogOut.bind(this)}
                                        onSetNavigationPage={this.setNavigationPage.bind(this)}
                                        onShowToast={this.showToast.bind(this)}
                                        smartFilingManager={this.props.smartFilingManager}
                                        officeWrapper={this.props.officeWrapper}
                                        formValidationHelpers={this.props.formValidationHelpers}
                                        submittalsApiService={this.props.submittalsApiService}
                                        projectsService={this.props.projectsService}
                                        mailboxItem={this.state.mailboxItem}
                                        analyticsManager={this.props.analyticsManager}
                                        nrnServiceWrapper={this.props.nrnServiceWrapper}
                                        msGraphApiService={this.props.msGraphApiService}
                                        theme={this.state.theme}
                                        invalidateCacheService={this.props.invalidateCacheService}
                                        isFilePathInAttachmentsSupported={this.state.isFilePathInAttachmentSupported}
                                        isNL1221Supported={this.state.isNL1221Supported}
                                        configService={this.props.configService}
                                        isSubmittalRespondCloseSupported={this.state.isSubmittalRespondCloseSupported}
                                        showRespondAndCloseSubmittalTeachingBubble={
                                            this.state.showRespondAndCloseSubmittalTeachingBubble
                                        }
                                        onDismissTeachingBubble={this.dismissRespondAndCloseSubmittalTeachingBubble}
                                        culture={this.state.culture}
                                        outlookApiService={this.props.outlookApiService}
                                    />
                                </Route>
                                <Route exact path="/rfi">
                                    {this.renderRfiComponent()}
                                </Route>
                                <Route exact path="/rfireviewresponse">
                                    <RfiReviewResponseComponent
                                        logger={this.props.logger}
                                        onExpiredSession={this.onUserLogOut.bind(this)}
                                        onSetNavigationPage={this.setNavigationPage.bind(this)}
                                        onShowToast={this.showToast.bind(this)}
                                        smartFilingManager={this.props.smartFilingManager}
                                        officeWrapper={this.props.officeWrapper}
                                        formValidationHelpers={this.props.formValidationHelpers}
                                        rfiApiService={this.props.rfiApiService}
                                        projectsService={this.props.projectsService}
                                        mailboxItem={this.state.mailboxItem}
                                        analyticsManager={this.props.analyticsManager}
                                        nrnServiceWrapper={this.props.nrnServiceWrapper}
                                        msGraphApiService={this.props.msGraphApiService}
                                        dateHelpers={this.props.dateHelpers}
                                        theme={this.state.theme}
                                        invalidateCacheService={this.props.invalidateCacheService}
                                        isFilePathInAttachmentsSupported={this.state.isFilePathInAttachmentSupported}
                                        isNL1221Supported={this.state.isNL1221Supported}
                                        configService={this.props.configService}
                                        isRfiRespondCloseSupported={this.state.isRfiRespondCloseSupported}
                                        showRespondAndCloseRfiTeachingBubble={
                                            this.state.showRespondAndCloseRfiTeachingBubble
                                        }
                                        onDismissTeachingBubble={this.dismissRespondAndCloseRfiTeachingBubble}
                                        culture={this.state.culture}
                                        outlookApiService={this.props.outlookApiService}
                                    />
                                </Route>
                                <Route exact path="/projectItem">
                                    <ProjectItemComponent
                                        smartFilingManager={this.props.smartFilingManager}
                                        logger={this.props.logger}
                                        mailboxItem={this.state.mailboxItem}
                                        emailApiService={this.props.emailApiService}
                                        onSetNavigationPage={this.setNavigationPage.bind(this)}
                                        onShowToast={this.showToast.bind(this)}
                                        onExpiredSession={this.onUserLogOut.bind(this)}
                                        deleteEmailAfterFiling={this.state.deleteEmailAfterFilingSetting}
                                        msGraphApiService={this.props.msGraphApiService}
                                        configurationsApiService={this.props.configurationsApiService}
                                        officeNotificationService={this.props.officeNotificationService}
                                        analyticsManager={this.props.analyticsManager}
                                        projectsService={this.props.projectsService}
                                        nrnServiceWrapper={this.props.nrnServiceWrapper}
                                        authApiService={this.props.authApiService}
                                        shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache={
                                            this.state.shouldShowMultipleEmailsTeachingBubbleAndInvalidateCache
                                        }
                                        theme={this.state.theme}
                                        invalidateCacheService={this.props.invalidateCacheService}
                                        messenger={this.props.messenger}
                                        officeRoamingSettings={this.props.officeRoamingSettings}
                                        onDismissTeachingBubble={this.dismissMultipleEmailsTeachingBubble.bind(this)}
                                        showNoProjectsToast={this.showNoProjectsToast.bind(this)}
                                        hideNoProjectsToast={this.hideNoProjectsToast.bind(this)}
                                        culture={this.state.culture}
                                        submittalsApiService={this.props.submittalsApiService}
                                        rfiApiService={this.props.rfiApiService}
                                        actionItemApiService={this.props.actionItemApiService}
                                        officeWrapper={this.props.officeWrapper}
                                        isProjectItemPendingExpectedSupported={
                                            this.state.isProjectItemPendingExpectedSupported
                                        }
                                    />
                                </Route>
                            </RedirectComponent>
                        </Switch>
                    </HashRouter>
                </div>
            </ThemeProvider>
        );
    }
}

export default withLocalize(AppComponent);
